<template>
  <Grid justify-content="center" class="header-checkbox">
    <RCheckbox v-model="model" />
  </Grid>
</template>

<script>
export default {
  computed: {
    module() {
      return this.params.filterParams.vuexModule
    },

    state() {
      return this.params.filterParams.vuexState
    },

    mutation() {
      return this.params.filterParams.vuexMutation
    },

    model: {
      get() {
        return this.$store.state[this.module][this.state]
      },
      set(val) {
        return this.$store.commit(`${this.module}/${this.mutation}`, val)
      }
    }
  }
}
</script>
